module.exports = __webpack_public_path__ + "img/clipboard-list.dd19eaa4.svg";